import React, { useState, useEffect } from 'react';
import {
  Typography,
  Button,
  TextField,
  List,
  ListItem,
  ListItemText,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import medidasImg from '../../assets/medidas.png';
import Layout from '../layouts/layout';

export default function Tamanho() {
  const [tipos, setTipos] = useState([]);
  const [tamanhos, setTamanhos] = useState([]);
  const [cores, setCores] = useState([]);
  const [selectedCor, setSelectedCor] = useState('');
  const [selectedTipo, setSelectedTipo] = useState('');
  const [novoGrupo, setNovoGrupo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('access');

  const [novoLargura, setNovoLargura] = useState('');
  const [novoFole, setNovoFole] = useState('');
  const [novoAltura, setNovoAltura] = useState('');
  const [novaGramagem, setNovaGramagem] = useState('');
  const [usaBadana, setUsaBadana] = useState(false);

  // Fetch tipos de saco and tamanhos
  useEffect(() => {
    setLoading(true);
    // Fetch tipos de saco
    fetch('https://plasticemployers.duckdns.org/api/op/tipo-sacos/', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Erro ao buscar tipos de saco');
        }
        return res.json();
      })
      .then((data) => {
        setTipos(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });

    // Fetch tamanhos
    setLoading(true);
    fetch('https://plasticemployers.duckdns.org/api/op/tamanhos/', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Erro ao buscar tamanhos');
        }
        return res.json();
      })
      .then((data) => {
        setTamanhos(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });

    // Fetch cores
    setLoading(true);
    fetch('https://plasticemployers.duckdns.org/api/op/cores/', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Erro ao buscar cores');
        }
        return res.json();
      })
      .then((data) => {
        setCores(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // Handle form submission to create novo tamanho
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const payload = {
      tipo_saco: selectedTipo,
      grupo: novoGrupo,
      largura: novoLargura,
      fole: novoFole,
      altura: novoAltura,
      usa_badana: usaBadana,
    };

    fetch('https://plasticemployers.duckdns.org/api/op/tamanhos/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((tamanhoData) => {
        // After creating the Tamanho, create the GramagemPorCor
        fetch('https://plasticemployers.duckdns.org/api/op/gramagens-por-cor/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            tamanho: tamanhoData.id,
            cor: selectedCor,
            gramagem: novaGramagem,
          }),
        })
          .then((res2) => {
            if (!res2.ok) {
              throw new Error('Erro ao criar gramagem por cor');
            }
            return res2.json();
          })
          .then((gramagemData) => {
            // Append the new Tamanho to the list (we keep the object simple)
            setTamanhos((prev) => [...prev, tamanhoData]);
            // Reset form fields
            setSelectedTipo('');
            setNovoGrupo('');
            setNovoLargura('');
            setNovoFole('');
            setNovoAltura('');
            setSelectedCor('');
            setNovaGramagem('');
            setUsaBadana(false);
            setLoading(false);
          })
          .catch((err2) => {
            setError(err2.message);
            setLoading(false);
          });
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  return (
    <Layout>
      <Typography variant="h4" gutterBottom>
        Tamanho
      </Typography>

      <Box sx={{ display: 'flex', mb: 4 }}>
        <Box component="form" onSubmit={handleSubmit} sx={{ width: 300, mr: 2 }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="tipo-saco-label">Tipo de Saco</InputLabel>
            <Select
              labelId="tipo-saco-label"
              value={selectedTipo}
              label="Tipo de Saco"
              onChange={(e) => setSelectedTipo(e.target.value)}
              required
            >
              {tipos.map((tipo) => (
                <MenuItem key={tipo.id} value={tipo.id}>
                  {tipo.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="grupo-label">Grupo</InputLabel>
            <Select
              labelId="grupo-label"
              value={novoGrupo}
              label="Grupo"
              onChange={(e) => setNovoGrupo(e.target.value)}
              required
            >
              <MenuItem value="vertical">Vertical</MenuItem>
              <MenuItem value="horizontal">Horizontal</MenuItem>
              <MenuItem value="take_away">Take Away</MenuItem>
              <MenuItem value="outro">Outro</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="cor-label">Cor</InputLabel>
            <Select
              labelId="cor-label"
              value={selectedCor}
              label="Cor"
              onChange={(e) => setSelectedCor(e.target.value)}
              required
            >
              {cores.map((cor) => (
                <MenuItem key={cor.id} value={cor.id}>
                  {cor.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Largura (cm)"
            type="number"
            value={novoLargura}
            onChange={(e) => setNovoLargura(e.target.value)}
            sx={{ mb: 2, width: '100%' }}
          />
          <TextField
            label="Fole (cm)"
            type="number"
            value={novoFole}
            onChange={(e) => setNovoFole(e.target.value)}
            sx={{ mb: 2, width: '100%' }}
          />
          <TextField
            label="Altura (cm)"
            type="number"
            value={novoAltura}
            onChange={(e) => setNovoAltura(e.target.value)}
            sx={{ mb: 2, width: '100%' }}
          />
          <TextField
            label="Gramagem (g/m²)"
            type="number"
            value={novaGramagem}
            onChange={(e) => setNovaGramagem(e.target.value)}
            sx={{ mb: 2, width: '100%' }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={usaBadana}
                onChange={(e) => setUsaBadana(e.target.checked)}
              />
            }
            label="Usa Badana"
            sx={{ mb: 2 }}
          />
          <Button type="submit" variant="contained" disabled={loading}>
            Adicionar Tamanho
          </Button>
        </Box>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={medidasImg} alt="Medidas" style={{ width: '60%' }} />
        </Box>
      </Box>

      {/* Exibir lista de Tamanhos */}
      {loading && <Typography>Carregando...</Typography>}
      {error && <Typography color="error">{error}</Typography>}
      {!loading && !error && (
        <List>
          {tamanhos.map((tamanho) => {
            const tipo = tipos.find((t) => t.id === tamanho.tipo_saco) || {};
            return (
              <ListItem key={tamanho.id}>
                <ListItemText
                  primary={`${tamanho.grupo} (${tipo.nome || ''})`}
                />
              </ListItem>
            );
          })}
        </List>
      )}
    </Layout>
  );
}